import * as styledComponents from 'styled-components'
import { ThemedStyledComponentsModule, ThemeProps } from 'styled-components'

import ThemeInterface from './theme'

const {
  default: styled,
  css,
  createGlobalStyle,
  keyframes,
  ThemeProvider,
} = styledComponents as ThemedStyledComponentsModule<ThemeInterface>

export { css, createGlobalStyle, keyframes, ThemeProvider, ThemeProps }
export default styled



// WEBPACK FOOTER //
// ./src/style/styled-components.ts